import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path:'/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: home
	}
]

const router = new VueRouter({
  mode: 'history',
  base: '/csggdt70/',
  routes
})

export default router
